(function () {
  const TIERS = [
    { handle: 'gift', threshold: 100 },
    { handle: 'extra-sheetmask-100-off', threshold: 5000 },
    { handle: 'mini-sized-product-100-off', threshold: 8000 },
    { handle: 'tote-bag', threshold: 12000 },
    { handle: 'full-sized-product-100-off', threshold: 15000 },
  ];
  const GIFT_HANDLES = TIERS.map((t) => t.handle);
  const SECTIONS = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
  const STORAGE_KEY = 'kbg-gift-variant-ids';
  const INTERNAL_HEADER = 'X-Kbg-Gift';

  const onCartPage = !!document.querySelector('cart-items');
  const variantIdCache = {};

  try {
    Object.assign(variantIdCache, JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'));
  } catch (_) {}

  function persistCache() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(variantIdCache));
    } catch (_) {}
  }

  function ensureVariantIds(handles) {
    const missing = (handles || GIFT_HANDLES).filter((h) => !variantIdCache[h]);
    if (!missing.length) return Promise.resolve();
    return Promise.all(
      missing.map((h) =>
        fetch(`/products/${h}.js`)
          .then((r) => (r.ok ? r.json() : null))
          .then((p) => {
            const id = p && p.variants && p.variants[0] && p.variants[0].id;
            if (id) variantIdCache[h] = id;
          })
          .catch(() => {})
      )
    ).then(persistCache);
  }

  function applySections(sections) {
    if (!sections) return;
    const parser = new DOMParser();
    const swap = (key, hostId, selector) => {
      const html = sections[key];
      if (!html) return;
      const doc = parser.parseFromString(html, 'text/html');
      const src = selector ? doc.querySelector(selector) : doc.querySelector('.shopify-section');
      const host = document.getElementById(hostId);
      if (!host) return;
      const dst = selector ? host.querySelector(selector) : host;
      if (src && dst) dst.innerHTML = src.innerHTML;
    };
    swap('main-cart-items', 'main-cart-items', '.js-contents');
    swap('main-cart-footer', 'main-cart-footer', '.js-contents');
    swap('cart-icon-bubble', 'cart-icon-bubble', null);
  }

  function computeOps(cart) {
    const giftLines = cart.items.filter((i) => GIFT_HANDLES.indexOf(i.handle) !== -1);
    const giftLinesTotal = giftLines.reduce((sum, i) => sum + i.final_line_price, 0);
    // Use total_price (after all discounts) so coupons/auto-discounts shift thresholds too.
    const nonGiftSubtotal = (cart.total_price || 0) - giftLinesTotal;

    const adds = [];
    const updates = {};

    TIERS.forEach((tier) => {
      const present = giftLines.find((g) => g.handle === tier.handle);
      const eligible = nonGiftSubtotal >= tier.threshold;
      if (eligible && !present) {
        const id = variantIdCache[tier.handle];
        if (id) adds.push({ id: id, quantity: 1 });
      } else if (!eligible && present) {
        updates[present.variant_id] = 0;
      } else if (eligible && present && present.quantity > 1) {
        updates[present.variant_id] = 1;
      }
    });
    return { adds, updates };
  }

  const origFetch = window.fetch;

  function internalFetch(url, body) {
    return origFetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        [INTERNAL_HEADER]: '1',
      },
      body: JSON.stringify(body),
    }).then((r) => (r.ok ? r.json() : null));
  }

  function doAdds(items, withSections) {
    const body = { items: items };
    if (withSections) body.sections = SECTIONS.join(',');
    return internalFetch('/cart/add.js', body);
  }

  function doUpdates(updates, withSections) {
    const body = { updates: updates };
    if (withSections) body.sections = SECTIONS.join(',');
    return internalFetch('/cart/update.js', body);
  }

  let syncing = false;
  let queued = false;

  async function runSync(cartData) {
    if (syncing) {
      queued = true;
      return;
    }
    syncing = true;
    try {
      await ensureVariantIds();
      const cart =
        cartData ||
        (await origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()));
      const { adds, updates } = computeOps(cart);
      const hasAdds = adds.length > 0;
      const hasUpdates = Object.keys(updates).length > 0;
      if (!hasAdds && !hasUpdates) return;

      let last = null;
      if (hasUpdates) last = await doUpdates(updates, onCartPage && !hasAdds);
      if (hasAdds) last = await doAdds(adds, onCartPage);
      if (onCartPage && last && last.sections) applySections(last.sections);
    } catch (e) {
      console.warn('[kbg-free-gifts] sync failed', e);
    } finally {
      syncing = false;
      if (queued) {
        queued = false;
        runSync();
      }
    }
  }

  // Site-wide: detect any external /cart/add.js call and trigger a gift sync after it resolves.
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const method = (init && init.method) || (input && input.method) || 'GET';
    const isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url) && /post/i.test(method);
    const headers = (init && init.headers) || {};
    const isInternal =
      headers[INTERNAL_HEADER] === '1' ||
      (typeof headers.get === 'function' && headers.get(INTERNAL_HEADER) === '1');

    const p = origFetch.apply(this, arguments);

    if (isAdd && !isInternal) {
      p.then(function (res) {
        if (res && res.ok) {
          // Small delay so Shopify's cart state is consistent before we read it.
          setTimeout(function () { runSync(); }, 30);
        }
      }).catch(function () {});
    }
    return p;
  };

  function init() {
    if (onCartPage) {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.cartData && Array.isArray(event.cartData.items)) {
            runSync(event.cartData);
          } else {
            runSync();
          }
        });
      }
      runSync();
    }
    // Prewarm variant IDs in the background (no-op if already cached in localStorage).
    ensureVariantIds();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
